import {
	SET_VALUE_ARRAY_SIZE_LIMIT,
	baseScopesRequiredPerField,
} from '@atlassian/ui-modifications-core/constants';

import { isAriResourceIdValid } from '@atlassian/ui-modifications-public-api-utils/is-ari-resource-id-valid';
import { isNotEmptyString } from '@atlassian/ui-modifications-public-api-utils/is-not-empty-string';

export type VersionsPublicSetValue = string[];

export type VersionValue = {
	id: string;
	name: string;
};

export const validateVersionValue = (value: unknown): value is VersionsPublicSetValue =>
	Array.isArray(value) &&
	value.every(isNotEmptyString) &&
	value.length <= SET_VALUE_ARRAY_SIZE_LIMIT;

export const validateVersionWithAriSetValue = (value: unknown): value is VersionsPublicSetValue =>
	Array.isArray(value) &&
	value.every((val) => isNotEmptyString(val) && isAriResourceIdValid(val)) &&
	value.length <= SET_VALUE_ARRAY_SIZE_LIMIT;

export const versionsRequiredScopes = {
	granular: [...baseScopesRequiredPerField.granular, 'read:project-version:jira'],
	coarse: [...baseScopesRequiredPerField.coarse],
};
